const Path = {
  '/unsubscribe': '/Desabonnement',
  '/desabonnement': '/Desabonnement',
  '/register': '/Inscription',
  '/inscription': '/Inscription',
  '/modify-preferences': '/Modifier-Preferences',
  '/modifier-preferences': '/Modifier-Preferences',
  '/activation-confirmation': '/Confirmation-Activation',
  '/confirmation-activation': '/Confirmation-Activation',
  '/activate-account': '/Activation-Compte',
  '/activation-compte': '/Activation-Compte',
};

const ActivateAccount = {
  Title: 'Félicitations!',
  Description:
    'Votre profil est maintenant complété et votre compte est presque prêt. Avant de vous laisser profiter de votre compte Familiprix, validons votre adresse courriel. Vérifiez vos pourriels si vous ne trouvez pas le courriel de confirmation dans votre boîte de réception. Une fois confirmé, nous vous laisserons personnaliser votre compte en trois étapes simples.',
  NotReceived: "Vous n'avez pas reçu le courriel?",
  SendNewEmail: 'Envoyez un nouveau courriel de confirmation',
  SuccessMessage:
    "Nous venons d'envoyer un courriel à {{email}} avec un lien qui vous permettra d'activer votre compte. Vérifiez votre boîte de réception dans les prochaines minutes. Si vous ne voyez pas l'e-mail, pensez à vérifier votre dossier SPAM.",
};

const Error = {
  Title: "Vous n'êtes pas connecté. Veuillez vous reconnecter pour continuer.",
};

const MetaTag = {
  RegisterTitle: "S'inscrire - Compte Familiprix",
  RegisterDescription:
    'Créez votre compte Familiprix dès maintenant et profitez de nos offres exclusives. Inscrivez-vous en quelques minutes et commencez à magasiner en ligne!',
  SettingTitle: 'Mes paramètres de compte - Compte Familiprix',
  SettingDescription:
    'Personnalisez votre compte Familiprix. Accédez facilement à vos informations de compte et gérez-les en toute simplicité.',
  AddAddressTitle: 'Ajouter une adresse - Compte Familiprix',
  AddAddressDescription:
    'Ajoutez une nouvelle adresse en un rien de temps avec le compte Familiprix. Facilitez vos achats en ligne avec une livraison rapide et pratique.',
  EditAddressTitle: 'Modifier une adresse - Compte Familiprix',
  EditAddressDescription:
    'Modifier vos adresses avec le compte Familiprix. Ajoutez de nouvelles adresses, gérez les existantes et facilitez vos achats en ligne avec une livraison rapide et pratique.',
  ShoppingPrefTitle: 'Préférences de magasinage - Compte Familiprix',
  ShoppingPrefDescription:
    'Personnalisez votre expérience de magasinage en ligne avec le compte Familiprix. Personnalisez votre compte en ajustant vos préférences de magasinage et plus encore.',
  CommunicationPrefTitle: 'Préférences de communication - Compte Familiprix',
  CommunicationPrefDescription:
    'Aidez nous à vous envoyer du contenu pertinent avec le compte Familiprix. Personnalisez votre compte en ajustant vos préférences de communications et plus encore.',
  FamiliplusTitle: 'Familiplus - Compte Familiprix',
  FamiliplusDescription:
    'Profitez des avantages exclusifs de Familiplus avec votre compte Familiprix. Économisez sur une tonne de produits, obtenez des récompenses et plus encore!',
  TransactionTitle: 'Familiplus - Transactions - Compte Familiprix',
  TransactionDescription:
    'Consultez votre historique de transactions Familiplus et suivez facilement vos points accumulés.',
  OESTitle: 'Familiplus - Opération Enfant Soleil - Compte Familiprix',
  OESDescription:
    'Utilisez vos points Familiplus afin de faire un don à Opération Enfant Soleil et contribuez à amasser des fonds pour les enfants malades.',
  ReplaceCardTitle: 'Familiplus - Changer ma carte - Compte Familiprix',
  ReplaceCardDescription:
    'Remplacez votre carte Familiplus perdue ou endommagée en quelques clics seulement grâce à votre compte Familiprix.',
  FamiliplusCardTitle: 'Familiplus - Devenir Membre - Compte Familiprix',
  FamiliplusCardDescription: 'Devenez membre Familiplus en quelques clics seulement grâce à votre compte Familiprix.',
  PreferenceCenterTitle: 'Centre de préférences - Familiprix',
  PreferenceCenterDescription: 'Gérér vos préférences facilement grâce à notre centre de préférences personnalisé.',
  UnsubscribeTitle: 'Désabonnement - Familiprix',
  UnsubscribeDescription: 'Désabonnement facile et rapide.',
  ActivationConfirmationTitle: 'Confirmation de votre création de compte - Familiprix',
  ActivationConfirmationDescription:
    'Votre compte est créé. Profitez maintenant pleinement de votre compte Familiprix.',
  RedirectTitle: 'Confirmation - Familiprix',
  RedirectDescription:
    'Votre compte est créé. Veuillez valider votre compte grâce au courriel que nous vous avons envoyé.',
  ActivateAccountTitle: 'Activer votre compte - Familiprix',
  ActivateAccountDescription: 'Activez votre inscription pour profiter pleinement de votre compte Familiprix.',
};

const FooterLinkTitle = {
  FAQ: 'FAQ',
  ContactUs: 'Nous joindre',
  FindAPharmacy: 'Trouver une pharmacie',
  Privacy: 'Politique de confidentialité',
  OnlinePurchase: "Politique d'achat en ligne",
  TermsAndConditions: 'Termes et conditions',
  GeneralTermsService: 'Conditions générales d’utilisation',
};

const Buttons = {
  Next: 'Suivant',
  Previous: 'Précédent',
  Skip: 'Passer',
  Cancel: 'Annuler',
  Confirm: 'Confirmer',
  Return: 'Retour',
  Add: 'Ajouter',
  Save: 'Enregistrer',
};

const LegalTitle = {
  Rights: 'Tous droits réservés. © Familiprix',
  Terms: "Conditions d'utilisation",
  PersonalPolicy: 'Politique sur les renseignements personnels',
  ReadAndAgree: "J'ai lu et j'accepte",
  PrivacyPolicy: 'Politique de confidentialité',
  Age: 'Je confirme être âgé de 14 ans ou plus',
  Data: 'Familiprix utilise mes données à des fins de personnalisation (facultatif)',
};

const Prepositions = {
  TheS: 'les',
  TheM: 'le',
  TheF: 'la',
  AndThe: 'et la',
  That: 'que',
  Your: 'votre',
  A: 'un',
  And: 'et',
  Our: 'nos',
};

const NavBar = {
  NavTitle: 'Création de compte',
  NavDescription: 'Veuillez suivre les différentes étapes pour créer votre compte',
};

const NavBarStepperLabel = {
  Informations: 'Informations',
};

const NavBarConnection = {
  ConnectionQuestion: 'Vous avez déjà un compte?',
  ConnectionLink: 'Se connecter',
};

const Form = {
  Field: 'champ',
  Optional: '(optionnel)',
  Email: 'Courriel',
  Password: 'Mot de passe',
  Confirmation: 'Confirmer le mot de passe',
  FirstName: 'Prénom',
  LastName: 'Nom',
  PhoneNumber: 'Numéro de téléphone',
  MobileNumber: 'Numéro de cellulaire',
  PhoneNumberMessage: 'Veuillez entrer au moins un numéro de téléphone',
  AddressLabel: "Nom de l'adresse",
  CivicNumber: 'Numéro civique',
  Street: 'Rue',
  Select: 'Sélectionner',
  Apartment: 'Appartement',
  City: 'Ville',
  Province: 'Province',
  PostalCode: 'Code postal',
  Country: 'Pays',
  InvoicePreference: 'Préférence de reçus',
  GenderPreference: 'Genre',
  Birthday: 'Date de naissance',
  Birthyear: 'Année de naissance',

  CardNumber: 'Numéro de carte',
};

const FormValidations = {
  ValidEmail: 'courriel valide',
  ValidPwd: 'mot de passe valide',
  ValidCardNumber: 'numéro de carte valide',
  ValidPhoneNumber: 'numéro de téléphone valide',
  AssiciatedWithAddress: 'associé à l’adresse',
  PleaseEnter: 'Veuillez entrer',
  PleaseConfirm: 'Veuillez confirmer',
  Required: 'Le champ {{field}} est requis',
  RequiredOnePhone: 'Veuillez entrer au moins un numéro de téléphone',
  InvalidFormat: 'Le format du {{field}} est invalide',
  InvalidField: '{{field}} invalide',
  FieldTooShort: "Le champ {{field}} doit être d'au moins {{length}} caractères",
  FieldTooLong: 'Le champ {{field}} ne doit pas dépasser {{length}} caractères',
  FieldIncorrectLength: 'Le champ {{field}} doit avoir {{length}} caractères',
  PasswordMustMatch: 'Mot de passe non identique',
  PrivacyPolicyRequired: 'Veuillez lire et accepter les Conditions d’utilisation et la Politique de confidentialité',
  AgeConsentRequired: 'Veuillez confirmer être âgé de 14 ans ou plus',
  InvalidBirthday: 'Veuillez entrer une date de naissance valide',
  MissingBirthyear: 'Veuillez entrer une année de naissance',
  TermsAndConditionRequired: 'Veuillez lire et accepter les Termes et conditions du programme Familiplus',
  passwordLength: 'Au moins 8 caractères',
  passwordCharTypes: 'Au moins 3 des 4 types de caractères suivants :',
  passwordLowercase: 'Minuscules (a-z)',
  passwordUppercase: 'Majuscules (A-Z)',
  passwordNumber: 'Chiffres (0-9)',
  passwordSpecialChar: 'Caractères spéciaux (!@#$%?&*)',
  passwordIdenticalChars: 'Pas plus de 2 caractères identiques de suite (exemple : « aaa » non permis)',
  InvalidName:
    'Le champ {{field}} contient des caractères invalides. Veuillez corriger et soumettre à nouveau.\r\nUniquement les caractères suivant sont acceptés : Lettres et chiffres avec ou sans accents (a-z, A-Z, 0-9), espaces, tirets ( - ) et les points ( . ).',
};

const Province = {
  AB: 'Alberta',
  BC: 'Colombie-Britannique',
  MB: 'Manitoba',
  NB: 'Nouveau-Brunswick',
  NL: 'Terre-Neuve-et-Labrador',
  NT: 'Territoires du Nord-Ouest',
  NS: 'Nouvelle-Écosse',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Île-du-Prince-Édouard',
  QC: 'Québec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
};

const Position = {
  1: '(1er)',
  2: '(2e)',
  3: '(3e)',
  4: '(4e)',
  5: '(5e)',
};

const InvoicePreference = {
  Paper: 'Papier seulement',
  Email: 'Courriel seulement',
  Both: 'Courriel et papier',
};

const GenderPreference = {
  Female: 'Féminin',
  Male: 'Masculin',
  Other: 'Non-genré',
};

const AuthenticationForm = {
  Title: 'Identification',
};

const AddressForm = {
  EditAddressTitle: 'Modifier une adresse',
  CreateAddressTitle: 'Ajouter une adresse',
  GetAddressError: `Une erreur est survenue lors de la récupération de l'adresse. Veuillez réessayer dans quelques minutes.`,
  AddressNotFound: `L'adresse demandée n'existe pas.`,
};

const ShoppingPreferencesForm = {
  Title: 'Préférences de magasinage',
};

const Languages = {
  ChangeTo: 'English',
  fr: 'Français',
  en: 'Anglais',
};

const BecomeAFamiliplusMember = {
  DontHaveACard: 'Vous n’avez pas de carte?',
  CreateOneHere: 'Faites-en la création ici.',
  CreateCard: 'Créer une carte',
  Title: 'Création de votre carte Familiplus',
  SubTitle: 'Type de carte souhaitée',
  VirtualCard: 'Carte virtuelle',
  PhysicalCard: 'Carte physique',
  IRead: 'J’ai lu et j’accepte les',
  TermsAndConditions: 'Termes et conditions du programme Familiplus',
  Mandatory: '(obligatoire)',
  PhysicalCardInfo:
    'Aucune carte en plastique ne sera émise en ligne. Pour obtenir une carte physique, veuillez vous rendre dans un Familiprix près de chez vous.',
};

const FamiliplusAdvantages = {
  Title: "C'est un gros plus",
  Info: 'Accumulez des points sur presque tous vos achats et obtenez rapidement des dollars de récompenses. Créez ou complétez votre profil en quelques minutes!',
  MemberPrice: 'Économisez grâce à nos Prix membre',
  BirthdayGift: 'Recevez un cadeau à votre anniversaire',
  PersonalizedOffers: 'Obtenez des offres personnalisées',
  FamiliplusMobile: 'Gagnez des points dans l’app mobile Familiplus',
  ExclusiveContests: 'Profitez de concours exclusifs',
  HealthyLife: 'Bougez et économisez avec Vie Saine',
};

const RegisterFamiliplusCard = {
  Title: 'Devenez membre Familiplus',
  AltTitle: 'Souscription Familiplus',
  SubTitle:
    'Vous avez déjà une carte? Entrez les informations suivantes et passez ensuite à la prochaine étape afin de l’activer.',
  CardNumber: 'Numéro de votre carte',
  AssociatedCardPhone: 'Numéro de téléphone associé à la carte',
  WarningPhoneNumber:
    'Votre profil Familiprix n’est pas associé à un numéro de téléphone. Avant de lier une carte existante à votre profil ou de devenir membre Familiplus, veuillez-vous rendre dans Paramètres du compte et en faire l’ajout. Merci de votre compréhension.',
};

const CommunicationPreferences = {
  Title: 'Préférences de communication',
  CommunicationLanguageTitle: 'Langue de communication',
  newsletterConsentTitle: 'Infolettre',
  newsletterConsentLabel:
    'J’accepte de recevoir des courriels de la part de Familiprix inc. et/ou de ses membres affiliés. Je comprends que je peux me désabonner à tout moment.',
  NewsletterContentTitle: 'Contenu des infolettres',
  OffresetpromotionsLabelInfo:
    'Recevez des promotions personnalisées et soyez avisé en premier des concours ainsi que des nouveaux produits offerts chez Familiprix.',
  ContenusantéLabelInfo:
    'Recevez des conseils en santé, basés sur vos intérêts. Soyez aussi avisé des nouvelles fonctionnalités de nos applications mobiles et profitez des avantages de connecter sa santé à Familiprix.',
  SmsConsentLabelInfo:
    "En cochant cette case, j'accepte les messages SMS de Familiprix. La fréquence des messages varie. Textez AIDE pour obtenir de l'aide et Textez ARRET ou désactivée cette case dans votre compte Familiprix pour vous désabonner. Des tarifs de messagerie et de données peuvent s'appliquer. En laissant cette case désactivée, vous n'activerez pas les messages SMS pour le moment.",
  ClickToView: 'Cliquez pour voir notre',
  personalizationTitle: 'Personnalisation',
  PersonalizationLabelInfo:
    "J’accepte de recevoir des communications personnalisées basées sur mes préférences, mes comportements de navigation et mon historique d'achat.",
  Interests: 'Intérêts',
  SubmitButton: 'Terminer',
};

const Errors = {
  ProfileExists: 'Le courriel {{email}} est déjà associé à un compte Familiprix.',
  MissingEmail:
    "Aucune adresse électronique n'a été trouvée dans la demande, essayez de vous connecter à nouveau et si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.",
  GetProfileError:
    "Un problème s'est produit lors de l'obtention des informations de votre compte. Veuillez réessayer dans quelques minutes. Si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.",
  ConnectHere: 'Cliquez-ici pour vous connecter.',
  CreateAccountServerError:
    "Une erreur s'est produite lors de la création de votre compte. Veuillez réessayer dans quelques minutes. Si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.",
  Associate404: 'Impossible de trouver cette carte. Veuillez vous assurer que les informations saisies sont exactes.',
  AlreadyAssociated: 'Cette carte est déjà associée sous un autre compte Familiprix.',
  Associate401:
    "Une erreur s'est produite. Si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.",
  GenericError:
    "Une erreur s'est produite. Attendez quelques minutes et réessayez. Si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.",
};

const Steps = {
  1: 'Identification',
  2: 'Inscription <logo />',
  3: 'Préférences de magasinage',
  4: 'Préférences de communication',
};

const RegisterConfirmation = {
  authTitle: 'Félicitations! Vous venez de créer votre compte Familiprix avec succès.',
  familiplusTitle: 'Félicitations!<br /> Vous venez de devenir membre Familiplus.',
  finalTitle: 'Votre profil a été personnalisé!',
  info: 'Pour une expérience sur mesure, veuillez remplir les prochaines étapes :',
  finalInfo: 'Vous serez redirigé à votre compte Familiprix dans quelques secondes.',
  NextStep: 'Suivant',
};

const ActivationConfirmation = {
  congratulation: 'Félicitations!',
  message: 'Votre compte Familiprix est maintenant actif.',
  finalInfo: 'Vous pouvez maintenant vous authentifier. Vous serez redirigé sous peu vers ',
};

const ReplaceFamiliplusCard = {
  Title: 'Remplacer ma carte',
  Info: 'En remplaçant votre numéro, votre ancienne carte ne fonctionnera plus. Votre solde sera transféré sur le nouveau compte.',
  CardNumber: 'Nouveau numéro de carte, situé au verso de la carte',
  Button: 'Changer ma carte',
  Success: 'Votre carte a été remplacée. La carte qui maintenant liée à votre compte Familiplus est la {{cardNumber}}.',
};

const AccountProfile = {
  Title: 'Compte',
  PersonalInfoSection: 'Mes informations',
  SecuritySection: 'Connexion & Sécurité',
  PasswordChangeButton: 'Changer le mot de passe',
  PasswordChangeSuccessMessage:
    "Nous venons d'envoyer un courriel à {{email}} avec un lien qui vous permettra de modifier votre mot de passe. Vérifiez votre boite de réception dans les prochaines minutes. Si vous ne voyez pas le courriel, pensez à vérifier votre dossier de courriel indésirable (SPAM).",
  SubmitButton: 'Enregistrer',
  fetchDataFailed:
    'Une erreur est survenue lors de la récupération de votre compte. Veuillez réessayer dans quelques minutes.',
  saveSuccess: 'Vos informations ont été enregistrées',
  MfaLabel: 'Code de validation',
  MfaDescription:
    'Le courriel est utilisé par défaut pour la vérification. Ajoutez le SMS ou la biométrie comme autres modes pour renforcer la sécurité.',
  MfaSmsLabel: 'SMS',
  MfaActive: 'Actif',
  MfaInactive: 'Non activé',
  MfaResetButton: 'Réinitialiser',
  MfaDisableConfirmTitle: 'Voulez-vous désactiver votre code de validation par SMS?',
  MfaDisableConfirmButton: 'Confirmer',
  MfaDisableCancelButton: 'Annuler',
  MfaResetSuccess:
    "Le facteur d'authentification SMS associé à votre compte a été réinitialisé. Lors de votre prochaine connexion, il vous sera demandé de le configurer à nouveau afin de protéger votre compte.",
};

const Preferences = {
  Title: 'Mes préférences',
  ShoppingTab: 'Magasinage',
  CommunicationsTab: 'Communications',
  FetchDataFailed:
    'Une erreur est survenue lors de la récupération de vos préférences. Veuillez réessayer dans quelques minutes. Si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.',
  SaveSuccess: 'Vos préférences ont été enregistrées',
  ShoppingDescription:
    "Renseignez vos préférences de magasinage afin de bénéficiez d'une expérience d'achat unique et distinctive",
  CommunicationDescription:
    'Renseignez vos préférences de communication et recevez du contenu adapté à vos intérêts vous permettant de vivre ce que nous avons de meilleur à offrir.',
};

const NotFound = {
  Title: 'Page introuvable',
};

const FamiliplusBonusPoints = {
  Title: 'Points bonus Familiplus',
  Description: 'Lorsque toutes les préférences de magasinage sont complétées',
};

const PreferenceCenter = {
  Title: 'Centre de préférences',
  Description:
    "Modifiez vos préférences afin de toujours bénéficier d'une expérience sur mesure et adaptée à vos intérêts.",
};

const UnsubscribePage = {
  Title: 'Nous sommes désolés de vous voir nous quitter!',
  Description1: 'Afin de confirmer votre désabonnement pour ',
  Description2:
    ', cliquez le bouton ci-dessous. Vous perdrez accès à nos offres promotionnelles personnalisées et à nos conseils en santé exclusifs. Vous ne pourrez aussi plus être avisé en premier des concours ainsi que des nouveaux produits offerts chez Familiprix.',
  PreferenceDescription: 'Si vous préférez ajuster vos préférences de communication, veuillez cliquer sur ',
  Confirm: 'Confirmer mon désabonnement',
  SeePreferences: 'Voir mes préférences',
  UnsubscribeConfirmation: 'Désabonnement de {{target}} confirmé.',
};

const Components = {
  Path,
  ActivateAccount,
  MetaTag,
  PreferenceCenter,
  Steps,
  FooterLinkTitle,
  Buttons,
  InvoicePreference,
  GenderPreference,
  LegalTitle,
  Position,
  Form,
  FormValidations,
  Prepositions,
  AuthenticationForm,
  AddressForm,
  ShoppingPreferencesForm,
  NavBar,
  Province,
  NavBarStepperLabel,
  NavBarConnection,
  Languages,
  CommunicationPreferences,
  Errors,
  RegisterFamiliplusCard,
  BecomeAFamiliplusMember,
  FamiliplusAdvantages,
  RegisterConfirmation,
  ActivationConfirmation,
  ReplaceFamiliplusCard,
  AccountProfile,
  Preferences,
  NotFound,
  FamiliplusBonusPoints,
  UnsubscribePage,
  Error,
};

export default Components;
